import React from "react";
import { Helmet } from "react-helmet-async";
import { Store } from "lucide-react";

interface ClosedStorePageProps {
  siteName: string;
  iconUrl?: string | null;
  title?: string;
  message?: string;
  contactEmail?: string | null;
}

const DEFAULT_TITLE = "現在、店舗を停止しています";
const DEFAULT_MESSAGE = "現在、この店舗のサービスを停止しています。ログイン・会員登録を含む各機能はご利用いただけません。";

const ClosedStorePage: React.FC<ClosedStorePageProps> = ({
  siteName,
  iconUrl,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  contactEmail,
}) => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6 py-12">
    <Helmet>
      <title>{title} | {siteName}</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <main className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white px-6 py-12 text-center shadow-sm sm:px-12">
      {iconUrl ? (
        <img src={iconUrl} alt="" className="mx-auto mb-6 h-20 w-20 rounded-2xl object-cover" />
      ) : (
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-slate-100">
          <Store className="h-10 w-10 text-slate-500" aria-hidden="true" />
        </div>
      )}
      <p className="mb-2 text-sm font-medium text-slate-500">{siteName}</p>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
      <p className="mt-5 whitespace-pre-line leading-7 text-slate-600">{message}</p>
      {contactEmail && (
        <p className="mt-6 text-sm text-slate-500">
          お問い合わせ: <a href={`mailto:${contactEmail}`} className="underline hover:text-slate-700">{contactEmail}</a>
        </p>
      )}
    </main>
  </div>
);

export default ClosedStorePage;
